import { application } from '@/controllers'

/*
 * Controllers that should be made available to ANY page in Parent
 * should be registered here. Try to keep smaller, generic, re-usable controllers
 * if it's going into the admin package.
 */

import FullEmailAlertController from '@/controllers/full_email_alert_controller'
application.register('full-email-alert', FullEmailAlertController)

import CheckInRefreshController from '@/controllers/admin/check_in_refresh_controller'
application.register('admin--check-in-refresh', CheckInRefreshController)
